import { useContext } from 'react'
import { UserContext } from './UserContext'

function useUserContext() {
  const ctx = useContext(UserContext)
  if (!ctx) {
    throw new Error('useAuth must be used within <UserContext.Provider>')
  }

  const { user } = ctx
  const isAdmin = user?.role === 'ADMIN'

  return {
    user,
    isAdmin,
  }
}

export default useUserContext
